import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/** Translated enum label: t('common:enums.<Enum>.<VALUE>'), falls back to the raw value. */
export function useEnumLabel() {
  const { t } = useTranslation('common');
  return useCallback(
    (enumName: string, value?: string | null) => (value ? t(`enums.${enumName}.${value}`, { defaultValue: value }) : '—'),
    [t],
  );
}
